<template>
	<div id="app" @click="selectBtn(index)" @contextmenu.prevent="selectBtn">
		<BackTop>
			<div>
				<img id='upbutton' v-if='btnFlag' src="./assets/img/topButton.png">
			</div>
		</BackTop>
		<div class="top_offsetIS" v-if="scroll===false">
			<MenuBar :scroll='scroll' />
		</div>
		<div class="top_offset" v-else>
			<MenuBar :scroll='scroll' />
		</div>
		<div class='main-body'>
			<router-view :key="key" />
		</div>
		<div class='bottom-bar'>
			<Row>
				<Col span="2">
				</Col>
				<Col span="20" class="my-bottom-content">
				<div class="my-top">
					<div class="top-left">
						<div class="top-left-img">
							<img src="./assets/img/bottom-logo.png">
						</div>
						<div class="top-left-word1">
							<h4>武汉市天鸿在线科技有限责任公司 </h4>
						</div>
						<div class="top-left-word2">
							<div class="my-bottom-word1">
								<div class="div1">
									<span class="span1d">传真号码</span><span class="span2d">027—87854441</span>
								</div>
								<div class="div2">
									<span class="span1d">邮箱地址</span><span class="span2d">master@thonline.com.cn</span>
								</div>
								<div class="div3">
									<span class="span1d">公司地址</span><span class="span2d">武汉市武昌区武珞路628号亚贸广场A座2711室</span>
									<!-- <p><span class="span1d">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="span2d">亚贸广场A座2711室</span></p> -->
								</div>
							</div>

						</div>
					</div>
					<div class="top-right">
						<div class="right-content1">
							<img src="./assets/img/027-87854441.png" />
						</div>
						<div class="right-content4">
							<Button type="primary">联系我们</Button>
						</div>
						<div class="right-content5">
							<router-link :to="{path:'solution'}">
								<span @click="go('2')">解决方案</span>
							</router-link>

							<router-link :to="{path:'productCenter'}">
								<span @click="go('3')">产品中心</span>
							</router-link>

							<router-link :to="{path:'CoreServices'}">
								<span @click="go('4')">核心服务</span>
							</router-link>

							<router-link :to="{path:'successCase'}">
								<span @click="go('5')">成功案例</span>
							</router-link>
							<router-link :to="{path:'productDemo'}">
								<span @click="go('6')">产品演示</span>
							</router-link>

							<router-link :to="{path:'aboutMe'}">
								<span @click="go('7')">关于我们</span>
							</router-link>
						</div>
						<div>
							<span class="content5_d">©2021 thonline.com.cn版权所有 鄂ICP备2022002729号</span>
							<div style="margin-top: 0.1rem;">
								<img src="./assets/img/badge.png" width="2%">
								<span class="content5_d">鄂公网安备 42010602004668号</span>
							</div>
						</div>
					</div>
				</div>
				</Col>
				<Col span="2">
				</Col>
			</Row>
		</div>
	</div>
</template>

<script>
	//Rem
	;
	(function(win, doc) {
		if (!win.addEventListener) return
		var html = document.documentElement

		function setFont() {
			var html = document.documentElement
			var k = 1920
			html.style.fontSize = (html.clientWidth / k) * 100 + 'px'
		}
		setFont()
		setTimeout(function() {
			setFont()
		}, 300)
		doc.addEventListener('DOMContentLoaded', setFont, false)
		win.addEventListener('resize', setFont, false)
		win.addEventListener('load', setFont, false)
	})(window, document)

	import MenuBar from '@/pages/components/MenuBar'
	import Arrow from '@/pages/components/Arrow'
	export default {

		name: 'App',
		components: {
			MenuBar,
			Arrow
		},
		computed: {
			key() {
				return this.$route.name ? this.$route.name + +new Date() : this.$route + +new Date()
			}
		},
		data() {
			return {
				btnFlag: false,
				/**头部样式滚动效果 */
				scroll: true
			}
		},
		methods: {
			//加计时器，使得返回顶部时有fade 的效果
			scrollToTop() {
				//alert('进入');，添加次语句可用于测试此时的浏览器窗口距离顶部是否》60
				//计算距离顶部的高度（高度大于60，显示返回按钮，否则隐藏）
				const that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				that.scrollTop = scrollTop;
				if (that.scrollTop > 0) {
					this.scroll = false
				} else {
					this.scroll = true
				}
				if (that.scrollTop > 60) {
					that.btnFlag = true;
				} else {
					that.btnFlag = false;
				}
			},
			go(index) {
				this.resetSetItem('index', index);
			}
		},
		mounted() {
			window.addEventListener('scroll', this.scrollToTop, true)
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop)
		}

	}
</script>

<style lang="less">
	@import './assets/sbws.css';

	html,
	body {
		height: 100%;
	}

	#app {
		height: 100%;
	}

	#upbutton {
		/*  设置图片相对于浏览器窗口固定*/
		position: fixed;
		/* 设置图片相对于浏览器的位置
      距离右边50px,底部20px,宽度50px
  */
		right: 50px;
		bottom: 20px;
		width: 50px;
		cursor: pointer;
	}

	.my-bottom-content {
		padding: 0 0.5rem;

		.my-top {
			display: flex;

			.top-left {
				flex: 2.2;

				.top-left-img {
					margin-top: 0.51rem;
					// margin-left: 0.7rem;
					width: 2rem;

					img {
						width: 100%;
					}
				}

				.top-left-word1 {
					margin-top: 0.2rem;

					h4 {
						font-size: 0.18rem;
						font-family: SourceHanSansCN-Medium;
						font-weight: normal;
						font-stretch: normal;
						letter-spacing: 0px;
						color: #ffffff;
					}
				}

				.top-left-word2 {
					display: flex;
					justify-content: space-between;
					margin-top: 0.1rem;

					.my-bottom-word1 {
						flex: 1.5;

						.div1 {
							margin-bottom: 0.1rem;
						}

						.div2 {
							margin-bottom: 0.1rem;
						}

						.div3 {
							margin-bottom: 0.5rem;
						}

						.span1d {
							font-size: 12px;
							font-weight: bold;
							margin-right: 0.3rem;

							font-family: SourceHanSansCN-Medium;
							font-weight: normal;
							font-stretch: normal;
							letter-spacing: 0px;
							color: #ffffff;
						}

						.span2d {
							font-size: 12px;
							font-family: SourceHanSansCN-Light;
							font-weight: normal;
							font-stretch: normal;
							letter-spacing: 0px;
							color: #ffffff;
							font-weight: lighter;
						}
					}
				}
			}

			.top-center {
				flex: 3;
				display: flex;
				margin-left: -0.8rem;

				.center-content1,
				.center-content2,
				.center-content3,
				.center-content4 {
					flex: 2;

					.center-top {
						margin-top: 0.7rem;

						span {
							color: #FFFFFF;
							font-size: 0.1rem;
						}
					}

					.center-bottom {
						p {
							margin-top: 0.1rem;
							color: #888888;
							font-size: 0.1rem;
							-webkit-transform: scale(0.75);
							-webkit-transform-origin-x: 12px;
						}
					}
				}

				.center-content2 {
					flex: 2;
				}

				.center-content3 {
					flex: 2;
				}

				.center-content4 {
					flex: 2;
				}
			}

			.top-right {
				flex: 3;
				text-align: right;

				.right-content1 {
					margin-top: 0.5rem;

					img {
						width: 30%;
					}
				}

				.right-content2 {
					p {
						margin-top: 0.1rem;
						color: #888888;
						font-size: 0.1rem;
						-webkit-transform: scale(0.75);
						-webkit-transform-origin-x: 0;
					}
				}

				.right-content3 {
					display: flex;
					margin-top: 0.2rem;

					.content3-img1 {
						flex: 1;
						width: 1rem;
						margin-right: 0.2rem;

						img {
							width: 100%;
						}
					}

					.content3-img2 {
						flex: 1;
						width: 1rem;

						img {
							width: 100%;
						}
					}
				}

				.right-content4 {
					width: 30%;
					/* margin: 70%; */
					margin-left: 70%;
					margin-top: 0.3rem;

					button {
						width: 100%;
						height: 0.4rem;
					}
				}

				.right-content5 {
					margin-top: 0.1rem;
					// margin-bottom: 0.11rem;
					margin-bottom: 0.13rem;

					font-family: SourceHanSansCN-Light;
					font-weight: normal;
					font-stretch: normal;
					letter-spacing: 0px;

					span {
						font-size: 12px;
						margin-left: 0.2rem;
						color: #9dadc1;
					}
				}
			}
		}

		.my-bottom {
			text-align: center;

			span {
				font-size: 0.1rem;
			}

			margin-top: 0.2rem;
		}
	}

	.top_offset {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		background-color: rgba(255, 255, 255, 0);

		.ivu-menu-light {
			background-color: rgba(255, 255, 255, 0);
		}
	}

	.top_offsetIS {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background: #FFFFFF;
		z-index: 1000;

		.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
		.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
			color: #333333 !important;
		}
	}

	.ivu-menu-horizontal .ivu-menu-item,
	.ivu-menu-horizontal .ivu-menu-submenu {
		padding: 0 0.2rem !important;
	}

	.ivu-menu-horizontal {
		height: 48px;
		line-height: 55px;
	}

	.ivu-menu-horizontal.ivu-menu-light:after {
		background: none !important;
	}

	.content5_d {
		font-family: SourceHanSansCN-Light;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #84848d;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue